import styles from '../Style/PointLayerMenu.module.scss';
import React, { useContext } from 'react';
import { StoreContext } from '../../../store/store';
import { IconBox } from '../../IconTool/IconTool';
import { LeftOutlined } from '@ant-design/icons';
import { ReactComponent as Layers } from '../../../icons/layers.svg';

export interface LayerOverviewProps {
  children?: React.ReactNode;
}

export default function LayerOverview(props: LayerOverviewProps) {
  const context = useContext(StoreContext);

  return (
    <div
      className={`${styles.root} ${
        context.menuCollapse ? styles.collapse : ''
      }`}
    >
      <div className={context.showLayerView ? '' : styles.hidden}>
        <IconBox
          className={`${styles.rightTopIcon} ${context.showLayerView ? '' : styles.hidden}`}
          onClick={() => context.setShowLayerView(false)}
        >
          <LeftOutlined />
        </IconBox>
        {props.children}
      </div>

      <IconBox
        className={`${styles.leftTopIcon} ${context.showLayerView ? styles.hidden : ''}`}
        onClick={() => context.setShowLayerView(true)}
      >
        <Layers />
      </IconBox>

    </div>
  );
}
